import React, { useContext } from "react";
import { BetslipContext } from "../../data/betslip/BetslipConf";
import Img from "../Img";
import { classIf } from "../../data/utils";
import { getLabel } from "../../InitData";
import { xs_isMobile } from "../..";

function getLabels() {
    let labels = null;
    if (xs_isMobile) {
        labels = [
            'betslip.odds_variation',
            'betslip.accept_odds_variation.always',
            'betslip.accept_odds_variation.increasing',
            'betslip.accept_odds_variation.never'
        ];
    } else {
        labels = [
            'carrello.odds_variation_toggle.label',
            'carrello.accept_odds_variation.always',
            'carrello.accept_odds_variation.increasing',
            'carrello.accept_odds_variation.never'
        ];
    }
    return labels.map(l => getLabel(l));
}

export default function Settings(props) {
    const betslipContext = useContext(BetslipContext);
    
    if (!betslipContext.isBetBuilder() && !betslipContext.isBetslipSettingsVisible()) {
        return null;
    }

    const betslipData = betslipContext.getBetslipData();
    const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    const varOdd = coupon.oddVariation;

    const toggleSettings = () => betslipContext.toggleBetslipSettings();
    const changeVarOdd = (oddVariation) => betslipContext.changeOddVariation(oddVariation, true);
    const [title, always, increasing, never] = getLabels();

    return (
        <div className="b_13">
            <div className="b_15">
                <div className="b_15_1">
                    <Img className="b_15_1_1" src="settings_button_betslip.svg" height="16px" width="16px" />
                    <span className="b_15_1_2">{getLabel('betslip.settings')}</span>
                    <Img className="b_15_1_3" src="icon_close.svg" height="24px" width="24px" onClick={toggleSettings} />
                </div>
                <div className="b_15_3">{title}</div>
                <div className={"b_15_2" + classIf(varOdd === 'ALWAYS', 'active')} onClick={() => changeVarOdd('ALWAYS')}>
                    <div className="b_17" />
                    <span className="b_15_2_2">{always}</span>
                </div>
                <div className={"b_15_2" + classIf(varOdd === 'INCR', 'active')} onClick={() => changeVarOdd('INCR')}>
                    <div className="b_17" />
                    <span className="b_15_2_2">{increasing}</span>
                </div>
                <div className={"b_15_2" + classIf(varOdd === 'NEVER', 'active')} onClick={() => changeVarOdd('NEVER')}>
                    <div className="b_17" />
                    <span className="b_15_2_2">{never}</span>
                </div>
            </div>
        </div>
    );
}
